"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
require("./settings.scss");
const Sentry = __importStar(require("@sentry/react"));
require("../sub-nav/tab-content.scss");
const container_1 = __importDefault(require("../account-navbar/container"));
const container_2 = __importDefault(require("../feedback/container"));
const container_3 = __importDefault(require("../header/container"));
const index_1 = __importDefault(require("../sub-nav/index"));
class Settings extends React.Component {
    render() {
        const { match: { path }, } = this.props;
        return (React.createElement(Sentry.ErrorBoundary, { beforeCapture: (scope) => {
                scope.setTag('error_boundary', 'settings');
            } },
            React.createElement("div", null,
                React.createElement(container_3.default, null),
                React.createElement(container_2.default, null),
                React.createElement(container_1.default, null,
                    React.createElement(index_1.default, { path: path })))));
    }
}
exports.default = Settings;
